import React from 'react';

import {
  AppLayout
} from 'AWS-UI-Components-React';

import {
  SummariesTable
} from './summaries_table'


const Content = () => (
  <div className='awsui-grid awsui-util-p-s'>
    <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
      <div className='col-xxs-12'>
          <div className='custom-home__header-title col-xxs-10 offset-xxs-1'>

            <div className='summariesTable'>
                 <SummariesTable />
            </div>

        </div>
      </div>
    </div>
    <div className='awsui-util-pt-xxl awsui-row'>
      <div className='col-xxs-10 offset-xxs-4 col-s-6 col-l-5 offset-l-2 col-xl-6'>
        <a href='https://w.amazon.com/bin/view/AWSFraudTeam/Intern/RecordTool/'>
           Wiki
        </a>
      </div>
      <div className='col-xxs-10 offset-xxs-6 col-s-6 col-l-5 offset-l-2 col-xl-6'>
        <a href='https://w.amazon.com/index.php/AWSFraudTeam/COPS'>
          Contact us
        </a>
      </div>
      <div className='custom-home__sidebar col-xxs-10 offset-xxs-1 col-s-4 offset-s-0 col-l-3 col-xl-2'>
        <div className='awsui-util-mt-xxl'>
          
          
        </div>
      </div>
    </div>
  </div>
);

export class Main extends React.Component {

  constructor(props){
      super(props);
    }

  render() {
    return (
      <div className="awsui">
        <AppLayout
                  className='awsui-util-no-gutters'
                  content={<Content/>}
                  navigationHide={true}
                  toolsHide={true}
                />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/main.jsx